module.exports = __webpack_public_path__ + "img/site.bd9f23bb.png";